
import { timeRangeOptions } from "@/utils/options";
import { FbaShipmentEnum } from "modules/common/logistics/enum";



export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '仓库',
    prop: 'warehouseIds',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'warehouseIds',
        propsData: {
            placeholder: '仓库',
            multiple: true,
            style: {
                width: '150px'
            }
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '状态',
    prop: 'status',
    components: [{
        name: 'gj-select',
        prop: 'status',
        propsData: {
            placeholder: '状态',
            options: FbaShipmentEnum.statusOption,
            multiple: true,
            collapseTags: true,
            style: {
                width: '190px'
            }
        }

    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '国家',
    prop: 'country',
    components: [{
        name: 'gj-country-select',
        prop: 'country',
        propsData: {
            multiple: true,
            collapseTags: true,
            style: {
                width: '140px'
            }
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
},  {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}]
